var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLauncherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 65,
    viewBox: "0 0 34 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bronze_Launcher/Rookie"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4621 0.454293L16.8504 0L16.2575 0.479232C10.6381 5.02126 8.07618 11.5267 7.12822 17.7133C6.22965 23.5776 6.76427 29.249 7.5868 32.9238L0 40.1278V58.4196L9.10658 48.8779H12.9051V63.9924C12.9051 64.5489 13.3496 65 13.8978 65C14.4461 65 14.8905 64.5489 14.8905 63.9924V46.8627H8.26568L1.9854 53.443V41.0022L9.79086 33.5905L9.64919 33.0153C8.80852 29.6021 8.18846 23.9069 9.09003 18.023C9.95542 12.3753 12.2053 6.64996 16.9028 2.55247C26.0031 9.80937 26.7412 22.0587 24.1014 33.0204L23.961 33.6034L32.0146 41.0117V53.4987L25.4769 46.8627H18.365V55.6794C18.365 56.2359 18.8094 56.6871 19.3577 56.6871C19.9059 56.6871 20.3504 56.2359 20.3504 55.6794V48.8779H24.6545L34 58.364V40.1183L26.1676 32.9134C28.7667 21.5688 27.9522 8.24537 17.4621 0.454293Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0949 14.8705C21.0949 17.0965 19.3171 18.901 17.1241 18.901C14.9311 18.901 13.1533 17.0965 13.1533 14.8705C13.1533 12.6445 14.9311 10.84 17.1241 10.84C19.3171 10.84 21.0949 12.6445 21.0949 14.8705ZM19.1095 14.8705C19.1095 15.9835 18.2206 16.8857 17.1241 16.8857C16.0276 16.8857 15.1387 15.9835 15.1387 14.8705C15.1387 13.7575 16.0276 12.8552 17.1241 12.8552C18.2206 12.8552 19.1095 13.7575 19.1095 14.8705Z",
    fill: "#003DA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauncherIcon);
export default __webpack_public_path__ + "static/media/launcher-icon.bc80b6821cae4a7cf13d874f95cede51.svg";
export { ForwardRef as ReactComponent };